<mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <mat-select [(ngModel)]="values" (selectionChange)="filter()" multiple>
        <mat-option *ngFor="let item of items" [value]="getKeyPropertyValue(item)">
            {{ getLabelPropertyValue(item) }}
        </mat-option>
    </mat-select>
</mat-form-field>

